import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "..";

interface InLaborState {
  isInLabor: boolean;
}

const initialState: InLaborState = { isInLabor: false };

const inLaborSlice = createSlice({
  name: "inLabor",
  initialState,
  reducers: {
    setInLabor: (state: InLaborState, action: PayloadAction<boolean>) => {
      state.isInLabor = action.payload;
    },
  },
});

export const { setInLabor } = inLaborSlice.actions;

export const selectIsInLabor = (state: RootState) => state.inLabor.isInLabor;

export default inLaborSlice.reducer;
